let key = 0
const generateUuid = () => {
    key = (key + 1) % 1e6
    const aux_string = Date.now().toString(36) + Math.random().toString(36).slice(2) + key.toString(36)
    return aux_string

}

export {
    generateUuid
}


// WEBPACK FOOTER //
// ./resources/js/helpers/generateUuid.js